module.exports = __webpack_public_path__ + "static/media/helpdesk_mailIcon.53440d6e.svg";